const baseKey = ['store'];
export const queryKeys = {
  commsBanner: (storeId: string | number) => [
    ...baseKey,
    'commsBanner',
    String(storeId),
  ],
  seo: (storeId: string | number) => [...baseKey, 'seo', String(storeId)],
  store: (storeId: string | number) => [...baseKey, String(storeId)],
};

export const urls = {
  commsBanner: (storeId: string | number) =>
    `/stores/${storeId}/banner_message_settings`,
  seo: (storeId: string | number) => `/stores/${storeId}/seo`,
  store: (storeId: string | number) => `/stores/${storeId}`,
};
